export function view(value) {
  return value?.isLoading
    ? 'Loading'
    : value?.sources.length > 0
    ? 'Content'
    : 'None'
}
